export default "{\n    \"selectedLabel\": \"{{count}} Technicians\",\n    \"placeholder\": \"Technician\"\n}\n"